module.exports = __webpack_public_path__ + "img/antonio.549b79a3.jpg";